import React, { useState, useEffect } from 'react'
import { MDBInput } from 'mdbreact';
import Select from 'react-select';
import paisesJson from './paises.json';
import { useMemo } from 'react';
import axios from 'axios'
import { uid } from 'uid';
import moment from 'moment'

const RegistraClientes = ({ setCheckFac, clienteRegis, setClienteRegis, ClienteaFinalizar, clienteTemporalSeleccionado, setClienteTemporalSeleccionado }) => {

	const [usuarios, setUsuarios] = useState([{ label: '1' }])
	const Base = process.env.REACT_APP_BASE_URL
	const Api = process.env.REACT_APP_API
	const baseUrlUsuarios = Base + Api + 'usuarios/'

	const traeUsers = async () => {
		await axios.get(baseUrlUsuarios, { params: { usuario: '1', clave: '1', unico: 'false' } })
			.then(response => {
				console.log('response', response)
				setUsuarios(response.data)

			}).catch(error => {
				console.log(error)
			})
	}

	useEffect(() => {
		traeUsers()
	}, [])

	const SubirCliente = (event, type) => {

		if (type === "select") {
			setClienteRegis({
				...clienteRegis,
				['pais']: event.label
			})
		} else {
			const target = event.target;
			const name = target.name;
			const value = target.value;
			setClienteRegis({
				...clienteRegis,
				[name]: value
			})
		}
	}

	const baseUrl = process.env.REACT_APP_BASE_URL
	const api = process.env.REACT_APP_API

	const urlUsuarios = baseUrl + api + 'usuarios/'
	const onSubmit = (e) => {
		e.preventDefault()

		let { nombres, email, pais, ciudad, estado, telefono } = clienteRegis

		let fechaCad = moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
		const fechaHoy = moment(new Date()).format("YYYY-MM-DD");

		let f = new FormData()
		f.append('activo', "Aprobado")
		f.append('usuario', (email ?? '').trim())
		f.append('clave', uid(12))
		f.append('roll', "Estudiante")
		f.append('nombre', (nombres ?? '').trim())

		f.append('fecha_ins', fechaHoy)
		f.append('fecha_cad', fechaCad)
		f.append('pais', (pais ?? '').trim())
		f.append('ciudad', (ciudad ?? '').trim())
		f.append('estado', (estado ?? '').trim())
		f.append('telefono', (telefono ?? '').trim())
		f.append('email', (email ?? '').trim())
		f.append('cursos', "[]")
		f.append('puntos', 0)
		f.append('id_stripe', ' ')
		f.append('temp', ' ')
		f.append('METHOD', 'POST')
		axios.post(urlUsuarios, f)
			.then(response => {
				const usuario = response.data;
				usuario['label'] = `${usuario.nombre} - ${usuario.usuario}`
				usuario['value'] = usuario.id
				usuario['nombres'] = usuario.nombre
				setClienteTemporalSeleccionado(usuario)
				setClienteRegis(usuario)
				ClienteaFinalizar('pago')
			}).catch(error => {
				console.log(error);
			})
	}

	const paises = useMemo(() =>
		paisesJson.map(pais => ({ label: pais.es_name, value: pais.es_name }))
		, [])



	const seleccionarCliente = () => {
		if (!clienteTemporalSeleccionado) return setClienteRegis()
		setClienteRegis(clienteTemporalSeleccionado)
		ClienteaFinalizar('pago')
		setCheckFac(true)
	}

	const validarClienteSeleccionado = (cliente) => {
		if (!cliente) {
			setClienteRegis()
			setCheckFac(false)
			setClienteTemporalSeleccionado(cliente)
			return
		}
		setClienteTemporalSeleccionado(cliente)
		setCheckFac(true)
	}

	return (
		<form onSubmit={onSubmit}>
			<React.Fragment>
				<div className="headerPasarela">
					<h4>Registrar Cliente:</h4>
				</div>
				<div className="CajaPasarela sombra">
					<div className="form-group">

						{clienteTemporalSeleccionado ?
							<div className="row" style={{ marginTop: '5px', marginBottom: '-25px' }}>
								<div className='col-md-12'>
									<Select
										placeholder={'Buscar Cliente'}
										options={usuarios}
										isClearable
										onChange={validarClienteSeleccionado}
										required
										styles={{ color: 'red' }}
										defaultValue={clienteRegis ? clienteRegis : null}
									/>
								</div>
								<div className='col-md-6'>
									<MDBInput required className="form-control campoClient" outline
										label="Nombres *"
										disabled
										value={clienteTemporalSeleccionado?.nombres}
										onChange={SubirCliente}
										key="nombresSelect"
									/>
								</div>
								<div className="col-md-6">
									<MDBInput label="Teléfono *" required outline className="form-control campoClient"
										disabled
										value={clienteTemporalSeleccionado?.telefono}
										onChange={SubirCliente}
										key="telefonoSelect"
									/>
								</div>
							</div> :
							<>
								<div className="row" style={{ marginTop: '5px', marginBottom: '-25px' }}>
									<div className='col-md-12'>
										<Select
											placeholder={'Buscar Cliente'}
											options={usuarios}
											isClearable
											onChange={validarClienteSeleccionado}
											styles={{ color: 'red' }}
											defaultValue={clienteRegis ? clienteRegis : null}
										/>
									</div>
									<div className='col-md-6'>
										<MDBInput
											required
											className="form-control campoClient" outline
											label="Nombres *"
											name="nombres"
											value={clienteRegis?.nombres}
											onChange={SubirCliente}
											key="nombres"
										/>
									</div>
									<div className="col-md-6">
										<MDBInput
											label="Teléfono *"
											required
											outline
											className="form-control campoClient"
											name="telefono"
											value={clienteRegis?.telefono}
											onChange={SubirCliente}
											key="telefono"
										/>
									</div>

								</div>

								<div className="row" style={{ marginTop: '-25px', marginBottom: '-25px' }}>
									<div className='col-md-6'>
										<MDBInput
											required
											className="form-control campoClient"
											outline
											label="Correo *"
											name="email"
											type='email'
											value={clienteRegis?.email}
											onChange={SubirCliente}
										/>
									</div>
									<div className='col-md-6 mt-4'>
										<Select
											name='pais'
											options={paises}
											placeholder="País"
											value={clienteRegis?.pais ? { label: clienteRegis.pais, value: clienteRegis.pais } : null}
											menuPosition={'fixed'}
											menuPortalTarget={document.body}
											onChange={(e) => SubirCliente(e, 'select')}
										/>
									</div>

								</div>
								<div className="row" style={{ marginTop: '-25px', marginBottom: '-25px' }}>
									<div className='col-md-6'>
										<MDBInput
											className="form-control campoClient" outline
											name="estado"
											label="Estado"
											value={clienteRegis?.estado}
											onChange={SubirCliente}
											key={'estado'}
										/>
									</div>
									<div className='col-md-6 '>
										<MDBInput className="form-control campoClient" outline
											name="ciudad"
											label="Ciudad "
											value={clienteRegis?.ciudad}
											onChange={SubirCliente}
										/>
									</div>

								</div>
								<div className="row" style={{ marginTop: '-25px', marginBottom: '-25px' }}>

									<div className='col-md-6'>
										<MDBInput className="form-control campoClient" outline
											name="direccion"
											label="Dirección"
											value={clienteRegis?.direccion}
											onChange={SubirCliente}
										/>
									</div>
								</div>
							</>

						}
					</div>
				</div>
				<div className="cont_botones_pasarela row">
					{clienteTemporalSeleccionado ?
						<div className='col-md-8'>
							<button

								type='button'
								onClick={seleccionarCliente}
								className="btn boton_estandar btn-lg gigante btn-block">
								Seleccionar Cliente
							</button>
						</div>
						:
						<div className='col-md-8'>
							<button
								type='submit'
								className="btn boton_estandar btn-lg gigante btn-block">
								Registrar Cliente
							</button>
						</div>}
					<div className='col-md-4'>
						<button
							onClick={() => ClienteaFinalizar('pago')}
							className="btn boton_estandar btn-lg gigante btn-block">
							Cancelar
						</button>
					</div>
				</div>

				<br />

			</React.Fragment>
		</form>
	)
}

export default RegistraClientes
